// Constants
import { GET_NEWS_DATA_SUCCESS } from "../../../../constants/nachritenConstants";

const initialState = {
  newsTableData: [],
};

const broadcastNewsReducer = (state, action) => {
  if (typeof state === "undefined") {
    state = initialState;
  }
  switch (action.type) {
    case GET_NEWS_DATA_SUCCESS:
      return Object.assign({}, state, {
        newsTableData: action.details,
      });

    default:
      return state;
  }
};

export default broadcastNewsReducer;
